import React, { useEffect, useState } from "react";
// import { Link, useStaticQuery, graphql } from "gatsby"
// import parse from "html-react-parser"
import Footer from "./build/footer/footer";
import Header from "./build/header/header";

const Layout = ({ isHomePage, children, withoutBg }) => {
  // const {
  //   wp: {
  //     generalSettings: { title },
  //   },
  // } = useStaticQuery(graphql`
  //   query LayoutQuery {
  //     wp {
  //       generalSettings {
  //         title
  //         description
  //       }
  //     }
  //   }
  // `)
  useEffect(() => {
    // Load Turnstile script
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector(
        'script[src="https://challenges.cloudflare.com/turnstile/v0/api.js"]'
      );
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div>
      <Header withoutBg={withoutBg} />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
